import { useState, useEffect } from 'react';
import { createPortalSession } from '../../Services/APIs/subscription';

const useBillingPortal = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        const handlePageShow = (event) => {
            if (event.persisted) {
                setIsLoading(false);
            }
        };
        window.addEventListener('pageshow', handlePageShow);
        return () => window.removeEventListener('pageshow', handlePageShow);
    }, []);

    const openPortal = async () => {
        setError('');
        setIsLoading(true);
        try {
            const response = await createPortalSession();
            setIsLoading(false);
            window.location.href = response.data.url;
        } catch (err) {
            if (err?.response?.status === 400) {
                setError('No active billing account yet.');
            } else {
                setError(err?.response?.data?.message || err?.data?.message || 'Something went wrong. Please try again.');
            }
            setIsLoading(false);
        }
    };

    return { openPortal, isLoading, error };
};

export default useBillingPortal;
